export const globalIp = 'https://gorohovip.ru';